import { TableColumnItemType } from '../types/type'

// 资金转入相关的列表：
export const columnForCapitalShiftTo: Array<TableColumnItemType> = [
  {
    title: '学校',
    key: 'school',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    needTransformForResult: 'enum',
    width: '200px'
  },
  {
    title: '转入资金金额（元）',
    key: 'transferAmount',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '转入时间',
    key: 'time',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '200px'
  },
  {
    title: '审批日期',
    key: 'approveTime',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '200px'
  },
  {
    title: '食堂专户名称',
    key: 'accountName',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '食堂专户账号',
    key: 'account',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '食堂专户开户行',
    key: 'depositBank',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '食堂专户开户行号',
    key: 'depositBankCode',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '200px'
  },
  {
    title: '转入至账户名称',
    key: 'receivingAccountName',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '转入至账户用户名',
    key: 'receivingAccount',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '转入至账号开户行',
    key: 'receivingDepositBank',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '150px'
  },
  {
    title: '转入至账号开户行号',
    key: 'receivingDepositBankCode',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '200px'
  },
  {
    title: '状态',
    key: 'status',
    type: 'tag',
    showStateForTableHeader: 'unilaminar',
    width: '200px'
  },
  {
    title: '编号',
    key: 'uniqueCode',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    width: '280px'
  },
  {
    title: '乡镇',
    key: 'town',
    type: 'text',
    showStateForTableHeader: 'unilaminar',
    needTransformForResult: 'enum',
    width: '200px'
  }
]
